import styled from 'styled-components';

const AboutUsSubtitle = styled.div`
  font-size: 15px;
  font-family: "Avenir Black", "Arial Black", sans-serif;
  text-align: center;
  text-align-last: center;
  line-height: 20px;
  display: flex;
  justify-content: center;
`;

export default AboutUsSubtitle;
